export const isValidUUID = (id?: string | null): boolean => {
  if (!id) return false;
  // Accept any UUID version (backend validator allows v1-5 by default)
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    id
  );
};
